
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Social"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M13.15 12.17l17.34 23.66h4.37L17.51 12.17h-4.36z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm13.64 36.24c.22.3.26.71.08 1.04-.17.34-.51.55-.89.55h-6.84a1 1 0 01-.81-.41l-7.27-9.91-10.03 10.03c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 010-1.41l10.25-10.25-10.35-14.11a.98.98 0 01-.08-1.04c.17-.34.51-.55.89-.55h6.84a1 1 0 01.81.41l7.27 9.91 10.03-10.03a.996.996 0 111.41 1.41L27.28 22.13l10.35 14.11z"}})])])
          )
        }
      }
    